import { AsyncPipe } from '@angular/common';
import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { DeviceStoreSelectors } from '@era/stores';
import { Store } from '@ngrx/store';
import { environment } from '@rocksoft/environment';
import { Device, EnvironmentFeatures, isNotUndefined } from '@rocksoft/shared';
import { Observable } from 'rxjs';
import { filter, switchMap } from 'rxjs/operators';
import { AppleDeviceService } from '../../../components/apple-device/apple-device.service';
import { DeviceDetailsContextMenuComponent } from './device-details-context-menu.component';

@Component({
  selector: 'era-device-details-context-menu',
  templateUrl: './device-details-context-menu.container.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [DeviceDetailsContextMenuComponent, AsyncPipe],
})
export class DeviceDetailsContextMenuContainerComponent {
  private readonly store = inject(Store);
  private readonly appleDeviceService = inject(AppleDeviceService);

  public readonly features: EnvironmentFeatures = environment.features;
  public readonly device$: Observable<Device> = this.store.select(DeviceStoreSelectors.selectCurrentDevice).pipe(
    filter(isNotUndefined),
    switchMap((device) => this.appleDeviceService.observeAppleDeviceWithLockedFlag(device))
  );
}
